import { render, staticRenderFns } from "./infos.vue?vue&type=template&id=7a215b31&scoped=true"
import script from "./infos.vue?vue&type=script&lang=js"
export * from "./infos.vue?vue&type=script&lang=js"
import style0 from "./infos.vue?vue&type=style&index=0&id=7a215b31&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a215b31",
  null
  
)

export default component.exports